module.exports = __webpack_public_path__ + "img/leisure_getaways.07a45ae1.svg";